"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactDom = require("react-dom");

var _UIImage = require("UIComponents/image/UIImage");

var _UIImage2 = _interopRequireDefault(_UIImage);

var _croppie = require("croppie");

var _croppie2 = _interopRequireDefault(_croppie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cropper = function (_Component) {
  _inherits(Cropper, _Component);

  function Cropper(props) {
    _classCallCheck(this, Cropper);

    var _this = _possibleConstructorReturn(this, (Cropper.__proto__ || Object.getPrototypeOf(Cropper)).call(this, props));

    _this.getCrop = _this.getCrop.bind(_this);
    return _this;
  }

  _createClass(Cropper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initializeCroppie();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var dataUrl = this.props.dataUrl;
      var nextDataUrl = nextProps.dataUrl;


      return dataUrl !== nextDataUrl;
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate() {
      this.croppie.destroy();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.initializeCroppie();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.croppie.destroy();
    }
  }, {
    key: "getCrop",
    value: function getCrop() {
      return this.croppie.result({
        type: "blob",
        size: {
          width: 100,
          height: 100
        },
        circle: false
      });
    }
  }, {
    key: "initializeCroppie",
    value: function initializeCroppie() {
      var imageNode = (0, _reactDom.findDOMNode)(this.cropImage);
      this.croppie = new _croppie2.default(imageNode, {
        viewport: {
          width: 200,
          height: 200,
          type: "circle"
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var dataUrl = this.props.dataUrl;

      var ref = function ref(c) {
        _this2.cropImage = c;
      };

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_UIImage2.default, { src: dataUrl, ref: ref })
      );
    }
  }]);

  return Cropper;
}(_react.Component);

Cropper.propTypes = {
  dataUrl: _react.PropTypes.string.isRequired
};

exports.default = Cropper;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./js/components/avatar/Cropper.js
// module id = 548
// module chunks = 171